import React from 'react';

export const PrivacyContent: React.FC = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 mb-6">Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">1. Verantwortlicher</h2>
      <p>
        Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
        Beyond Pages<br />
        Glasstr. 84
        50823 Köln <br />
        E-Mail: info@beyondpages.io
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">2. Erhebung und Speicherung personenbezogener Daten</h2>
      
      <h3 className="text-xl font-semibold mt-6 mb-3">2.1 Beim Besuch der Website</h3>
      <p>
        Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch Informationen an den Server unserer Website gesendet. Diese Informationen werden temporär in einem sog. Logfile gespeichert. Folgende Informationen werden dabei ohne Ihr Zutun erfasst und bis zur automatisierten Löschung gespeichert:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>IP-Adresse des anfragenden Rechners</li>
        <li>Datum und Uhrzeit des Zugriffs</li>
        <li>Name und URL der abgerufenen Datei</li>
        <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
        <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners</li>
      </ul>

      <h3 className="text-xl font-semibold mt-6 mb-3">2.2 Bei der Registrierung</h3>
      <p>
        Für die Nutzung unseres Services ist eine Registrierung erforderlich. Dabei werden folgende Daten erhoben:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>E-Mail-Adresse</li>
        <li>Name (optional)</li>
        <li>Firmenname (bei Teamaccounts)</li>
      </ul>

      <h3 className="text-xl font-semibold mt-6 mb-3">2.3 Bei der Nutzung von QR-Codes</h3>
      <p>
        Beim Scannen von QR-Codes erfassen wir zu Analysezwecken:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Zeitpunkt des Scans</li>
        <li>Ungefährer Standort (Land, basierend auf IP-Adresse)</li>
        <li>Gerätetyp (basierend auf User-Agent)</li>
        <li>Anonymisierte IP-Adresse</li>
      </ul>
      <p>
        Diese Daten werden ausschließlich in aggregierter Form an die Ersteller der QR-Codes weitergegeben und dienen der Analyse der Reichweite ihrer Inhalte.
      </p>

      <h3 className="text-xl font-semibold mt-6 mb-3">2.4 E-Mail-Erfassung bei geschützten Inhalten</h3>
      <p>
        Bei bestimmten Inhalten (z.B. Leseproben mit E-Mail-Gate) kann die Eingabe einer E-Mail-Adresse erforderlich sein. Diese wird nur gespeichert, wenn Sie diese freiwillig eingeben, und wird ausschließlich für den angegebenen Zweck verwendet.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">3. Rechtsgrundlage für die Datenverarbeitung</h2>
      <p>
        Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten ist:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) für optionale Datenangaben</li>
        <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) für die Bereitstellung unseres Services</li>
        <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen) für die Analyse und Verbesserung unseres Angebots</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">4. Weitergabe von Daten</h2>
      <p>
        Eine Übermittlung Ihrer persönlichen Daten an Dritte findet nicht statt, außer:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Sie haben ausdrücklich eingewilligt (Art. 6 Abs. 1 lit. a DSGVO)</li>
        <li>Die Weitergabe ist zur Vertragserfüllung erforderlich (Art. 6 Abs. 1 lit. b DSGVO)</li>
        <li>Wir sind gesetzlich dazu verpflichtet (Art. 6 Abs. 1 lit. c DSGVO)</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">5. Cookies</h2>
      <p>
        Wir verwenden technisch notwendige Cookies, um die Funktionalität unserer Website zu gewährleisten. Diese Cookies werden automatisch gelöscht, wenn Sie Ihren Browser schließen (Session-Cookies).
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">6. Hosting und Content Delivery</h2>
      <p>
        Unsere Website wird bei folgenden Dienstleistern gehostet:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Supabase:</strong> Für Datenbank und Authentifizierung</li>
        <li><strong>Vercel/Netlify:</strong> Für das Frontend-Hosting</li>
        <li><strong>Heroku:</strong> Für das Backend-Hosting</li>
      </ul>
      <p>
        Mit diesen Dienstleistern haben wir Auftragsverarbeitungsverträge abgeschlossen, die den Schutz Ihrer Daten gewährleisten.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">7. Ihre Rechte</h2>
      <p>
        Sie haben folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Auskunftsrecht (Art. 15 DSGVO):</strong> Sie können Auskunft über Ihre gespeicherten Daten verlangen</li>
        <li><strong>Berichtigungsrecht (Art. 16 DSGVO):</strong> Sie können die Berichtigung unrichtiger Daten verlangen</li>
        <li><strong>Löschungsrecht (Art. 17 DSGVO):</strong> Sie können die Löschung Ihrer Daten verlangen</li>
        <li><strong>Einschränkungsrecht (Art. 18 DSGVO):</strong> Sie können die Einschränkung der Verarbeitung verlangen</li>
        <li><strong>Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie können Ihre Daten in einem strukturierten Format erhalten</li>
        <li><strong>Widerspruchsrecht (Art. 21 DSGVO):</strong> Sie können der Verarbeitung widersprechen</li>
        <li><strong>Widerrufsrecht (Art. 7 Abs. 3 DSGVO):</strong> Sie können erteilte Einwilligungen jederzeit widerrufen</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">8. Speicherdauer</h2>
      <p>
        Wir speichern Ihre personenbezogenen Daten nur so lange, wie dies für die Erfüllung der Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen dies vorsehen:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Kontodaten: Bis zur Löschung Ihres Accounts</li>
        <li>QR-Code-Analysen: 12 Monate</li>
        <li>E-Mail-Adressen bei geschützten Inhalten: 6 Monate oder bis zum Widerruf</li>
        <li>Server-Logs: 7 Tage</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">9. Datensicherheit</h2>
      <p>
        Wir verwenden geeignete technische und organisatorische Sicherheitsmaßnahmen, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust, Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">10. Beschwerderecht</h2>
      <p>
        Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">11. Änderungen dieser Datenschutzerklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">12. Kontakt</h2>
      <p>
        Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten, bei Auskünften, Berichtigung, Sperrung oder Löschung von Daten wenden Sie sich bitte an:<br />
        E-Mail: info@beyondpages.io
      </p>
    </div>
  );
};

export default PrivacyContent;

